import React, { Component } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import {
  Box,
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  CircularProgress,
  Pagination,
  ButtonGroup,
  InputAdornment,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import { apiUrl } from "../../comp/ApiUrl";

class Categorias extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      stores: [],
      loader: true,
      searchTerm: "",
      currentPage: 1,
      itemsPerPage: 50,
      openNew: false,
      editItem: null,
      deleteItem: null,
      formData: { nome: "", loja: "", ativo: "Y", delivery: "N" },
    };
  }

  componentDidMount() {
    document.title = "Categorias Loja | FazPedido";
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const response = await fetch(`${apiUrl}/categorias/loja`, {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userToken"),
        },
      });
      if (response.ok) {
        const result = await response.json();
        this.setState({
          stores: result.stores || [],
          data: result.categories || [],
        });
      }
    } catch (error) {
      toast.error("Erro ao carregar dados.");
    } finally {
      this.setState({ loader: false });
    }
  };

  handleSearch = (e) => {
    this.setState({
      searchTerm: e.target.value.toLowerCase(),
      currentPage: 1,
    });
  };

  moverItem = async (index, direction) => {
    const { data, currentPage, itemsPerPage } = this.state;
    const newData = [...data];
    const actualIndex = (currentPage - 1) * itemsPerPage + index;

    if (direction === "up" && actualIndex > 0) {
      [newData[actualIndex - 1], newData[actualIndex]] = [
        newData[actualIndex],
        newData[actualIndex - 1],
      ];
    } else if (direction === "down" && actualIndex < newData.length - 1) {
      [newData[actualIndex + 1], newData[actualIndex]] = [
        newData[actualIndex],
        newData[actualIndex + 1],
      ];
    }

    const orderedData = newData.map((item, i) => ({ ...item, posicao: i + 1 }));
    this.setState({ data: orderedData });

    try {
      await fetch(`${apiUrl}/categorias/delivery/reordenar`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("auth_token"),
        },
        body: JSON.stringify({
          categorias: orderedData.map((item) => ({
            id: item.id,
            posicao: item.posicao,
          })),
        }),
      });
      toast.success("Ordem atualizada!");
    } catch (error) {
      toast.error("Erro ao salvar ordem.");
    }
  };

  handleSave = async (isEdit = false) => {
    const { editItem, formData } = this.state;
    const payload = isEdit ? editItem : formData;
    try {
      const response = await fetch(`${apiUrl}/categoria/delivery`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("auth_token"),
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        toast.success(
          isEdit ? "Atualizado com sucesso!" : "Cadastrado com sucesso!"
        );


        this.setState((prevState) => ({

          data: isEdit
            ? prevState.data.map((item) =>
              item.id === payload.id ? { ...item, ...payload } : item
            )
            : [...prevState.data, payload],
          openNew: false,
          editItem: null,
          formData: { nome: "", loja: "", ativo: "Y", delivery: "N" },

        }))


      }
    } catch (error) {
      toast.error("Erro ao salvar.");
    }
  };

  render() {
    const {
      data,
      loader,
      searchTerm,
      currentPage,
      itemsPerPage,
      openNew,
      editItem,
      deleteItem,
      formData,
    } = this.state;

    if (loader) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      );
    }

    const filteredData = data.filter((item) =>
      item.nome?.toLowerCase().includes(searchTerm)
    );

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

    return (
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Paper sx={{ p: 2, mb: 3 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={2}
          >
            <TextField
              size="small"
              placeholder="Pesquisar..."
              value={searchTerm}
              onChange={this.handleSearch}
              sx={{ width: { xs: "100%", md: "40%" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => this.setState({ openNew: true })}
            >
              Nova Categoria
            </Button>
          </Box>
        </Paper>

        <Paper sx={{ p: 0 }}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell align="center">Posição</TableCell>
                  <TableCell align="center">Nome</TableCell>
                  <TableCell align="center">N. Produtos</TableCell>
                  <TableCell align="center">Ativo</TableCell>
                  <TableCell align="center">Catálogo</TableCell>
                  <TableCell>Criado Em</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      Nenhuma categoria encontrada.
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map((item, index) => (
                    <TableRow key={item.id || index} hover>
                      <TableCell align="center">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </TableCell>
                      <TableCell align="center">
                        {item.nome}
                      </TableCell>
                      <TableCell align="center">{item.NProdutos || 0}</TableCell>
                      <TableCell align="center">
                        {item.ativo === "Y" ? "Sim" : "Não"}
                      </TableCell>
                      <TableCell align="center">
                        {item.delivery === "Y" ? "Sim" : "Não"}
                      </TableCell>
                      <TableCell>
                        {item.created_at
                          ? new Date(item.created_at).toLocaleDateString()
                          : "---"}
                      </TableCell>
                      <TableCell align="right">
                        <ButtonGroup size="small" variant="outlined">
                          <IconButton
                            color="primary"
                            onClick={() => this.setState({ editItem: item })}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            disabled={index === 0 && currentPage === 1}
                            onClick={() => this.moverItem(index, "up")}
                          >
                            <ArrowUpwardIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            disabled={
                              index === paginatedData.length - 1 &&
                              currentPage === totalPages
                            }
                            onClick={() => this.moverItem(index, "down")}
                          >
                            <ArrowDownwardIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => this.setState({ deleteItem: item })}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </ButtonGroup>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box display="flex" justifyContent="center" mt={3}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(e, value) => this.setState({ currentPage: value })}
              color="primary"
            />
          </Box>
        </Paper>

        {/* Modal Novo/Editar */}
        <Dialog
          open={openNew || !!editItem}
          onClose={() => {
            this.setState({ openNew: false, editItem: null });
          }}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            {editItem ? "Editar Categoria" : "Nova Categoria"}
          </DialogTitle>
          <DialogContent dividers>
            <Box display="flex" flexDirection="column" gap={2} mt={1}>
              <TextField
                fullWidth
                label="Nome da Categoria"
                value={editItem ? editItem.nome : formData.nome}
                onChange={(e) => {
                  if (editItem) {
                    this.setState({
                      editItem: { ...editItem, nome: e.target.value },
                    });
                  } else {
                    this.setState({
                      formData: { ...formData, nome: e.target.value },
                    });
                  }
                }}
              />

              <Box display="flex" gap={2}>
                <TextField
                  select
                  sx={{ width: 120 }}
                  label="Ativo"
                  value={editItem ? editItem.ativo : formData.ativo}
                  onChange={(e) => {
                    if (editItem) {
                      this.setState({
                        editItem: { ...editItem, ativo: e.target.value },
                      });
                    } else {
                      this.setState({
                        formData: { ...formData, ativo: e.target.value },
                      });
                    }
                  }}
                >
                  <MenuItem value="Y">Sim</MenuItem>
                  <MenuItem value="N">Não</MenuItem>
                </TextField>

                <TextField
                  select
                  sx={{ width: 120 }}
                  label="Catalogo"
                  value={editItem ? editItem.delivery : formData.delivery}
                  onChange={(e) => {
                    if (editItem) {
                      this.setState({
                        editItem: { ...editItem, delivery: e.target.value },
                      });
                    } else {
                      this.setState({
                        formData: { ...formData, delivery: e.target.value },
                      });
                    }
                  }}
                >
                  <MenuItem value="Y">Sim</MenuItem>
                  <MenuItem value="N">Não</MenuItem>
                </TextField>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ openNew: false, editItem: null });
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={() => this.handleSave(!!editItem)}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal Deletar */}
        <Dialog
          open={!!deleteItem}
          onClose={() => this.setState({ deleteItem: null })}
        >
          <DialogTitle>Confirmar Exclusão</DialogTitle>
          <DialogContent>
            Deseja realmente remover a categoria{" "}
            <strong>{deleteItem?.nome}</strong>?
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ deleteItem: null })}>
              Cancelar
            </Button>
            <Button color="error" variant="contained" onClick={() => {
              fetch(`${apiUrl}/categoria/delivery/${deleteItem.id}`, {
                method: "DELETE",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then((response) => {
                  if (response.ok) {
                    this.setState((prevState) => ({
                      data: prevState.data.filter(
                        (item) => item.id !== deleteItem.id
                      ),
                      deleteItem: null,
                    }));
                    toast.success("Categoria removida com sucesso!");
                  } else {
                    toast.error("Erro ao remover categoria.");
                  }
                })
                .catch(() => {
                  toast.error("Erro ao remover categoria.");
                });
            }}>
              Remover
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    );
  }
}

export default Categorias;